import React from 'react';
import { MessageCircle } from 'lucide-react';
import { motion } from 'framer-motion';
import { useSettings } from '../hooks/useSettings';
import { useLocation } from 'react-router-dom';

const WhatsAppButton: React.FC = () => {
  const { settings } = useSettings();
  const location = useLocation();

  const handleWhatsAppClick = () => {
    const phoneNumber = settings?.whatsapp_number || process.env.REACT_APP_WHATSAPP_NUMBER || '5511999999999';
    
    let baseText = 'Olá, Dra. Luara! Acessei seu site e gostaria de uma análise sobre meu caso.';
    
    if (location.pathname.includes('/blog')) {
        baseText = 'Olá, Dra. Luara! Estava lendo o blog do escritório e preciso de ajuda com meu caso.';
    } else if (location.pathname.includes('/contato')) {
        baseText = 'Olá! Preciso falar urgente com um advogado do escritório.';
    }

    const message = encodeURIComponent(baseText);
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');
  };

  return (
    <motion.button
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
      onClick={handleWhatsAppClick}
      className="btn-whatsapp"
      aria-label="Falar no WhatsApp"
    >
      <MessageCircle size={24} />
    </motion.button>
  );
};

export default WhatsAppButton;